import * as THREE from 'three';
import { Group, AnimationMixer, Clock } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import store from '../store';
import screenStore from '@blade-sxp/screen/store/index';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js';
// import { MeshLineRaycast } from 'meshline';
import { loadePerson, Gender, getModelSize } from '@blade-sxp/map/utils/persons';
import { PathGeometry, PathPointList } from 'three.path';
// 格式化线上的点
const getPointList = (points) => {
    let bgPointList = [];
    points.forEach((point, i) => {
        bgPointList = bgPointList.concat([point[0], point[1] + 0.5, point[2]]);
    });
    return bgPointList;
};
// 获取一段距离的随机点位
function rand(m, n) {
    return Math.ceil(Math.random() * (n - m + 1) + m - 1);
}
// 底线
class MyPath {
    pointsArr;
    pointPercentArr;
    line;
    preUp; // 上次方向
    perce;
    speed;
    turnFactor;
    turnSpeedFactor;
    obj;
    preTime;
    firstTurn;
    flowingLineTexture;
    model;
    curve;
    progress = 0.15; // 物体运动时在运动路径的初始位置，范围0~1
    velocity = 0.01; // 影响运动速率的一个值，范围0~1，需要和渲染频率结合计算才能得到真正的速率
    modelType;
    num = 1;
    pathPoints = [];
    pathCurve = [];
    lineType = '';
    constructor(array, speed, linewidth, percePosition, cycle, lineType, model) {
        console.log(PathGeometry, 'PathGeometry');
        const pointsArr = [];
        const arrayLength = array.length;
        for (let index = 0; index < arrayLength; index += 3) {
            pointsArr.push(new THREE.Vector3(array[index], array[index + 1], array[index + 2]));
        }
        this.pointsArr = pointsArr;
        const realDistanceArr = []; // 每段距离
        let realSumDistance = 0; // 总距离
        for (let index = 0; index < this.pointsArr.length - 1; index++) {
            realDistanceArr.push(this.pointsArr[index].distanceTo(this.pointsArr[index + 1]));
        }
        realSumDistance = realDistanceArr.reduce(function (tmp, item) {
            return tmp + item;
        });
        // 将传进来的数组转换为Vec3集合
        this.progress = percePosition;
        this.lineType = lineType;
        const realTime = realSumDistance / speed;
        this.velocity = this.velocity / (realTime / 10) * 2;
        this.model = model;
        const mapImage = require(`@blade-sxp/map/src/assets/${lineType}.png`);
        // 加载纹理
        this.flowingLineTexture = new THREE.TextureLoader().load(mapImage);
        // // 贴图在水平方向上允许重复
        this.flowingLineTexture.wrapS = THREE.RepeatWrapping;
        if (lineType === 'Pulse' || lineType === 'Full line') {
            this.flowingLineTexture.repeat.set(0.01, 1);
        }
        // 确定一个向上的向量
        const up = new THREE.Vector3(0, 1, 0);
        // region 引入three.path包
        const material = new THREE.MeshPhongMaterial({
            map: this.flowingLineTexture,
            transparent: true,
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            emissive: new THREE.Color(0x3295FB),
        });
        // material.color.set(0x00ffe9)
        // 创建路径点的集合
        this.pathPoints = new PathPointList();
        this.pathCurve = new THREE.CatmullRomCurve3(pointsArr, false, 'catmullrom', 0);
        // 设置集合属性
        this.pathPoints.set(this.pathCurve.getPoints(50), 0.5, 2, up, false);
        // 创建路径几何体
        const geometry = new PathGeometry();
        // 更新几何体的属性
        geometry.update(this.pathPoints, {
            width: 1 * linewidth,
            arrow: false
        });
        this.line = new THREE.Mesh(geometry, material);
        this.curve = new THREE.CatmullRomCurve3(pointsArr);
        // 计算每个锚点在整条折线上所占的百分比
        this.pointPercentArr = [];
        {
            const distanceArr = []; // 每段距离
            let sumDistance = 0; // 总距离
            for (let index = 0; index < this.pointsArr.length - 1; index++) {
                distanceArr.push(this.pointsArr[index].distanceTo(this.pointsArr[index + 1]));
            }
            sumDistance = distanceArr.reduce(function (tmp, item) {
                return tmp + item;
            });
            const disPerSumArr = [0];
            disPerSumArr.push(distanceArr[0]);
            distanceArr.reduce(function (tmp, item) {
                disPerSumArr.push(tmp + item);
                return tmp + item;
            });
            disPerSumArr.forEach((value, index) => {
                disPerSumArr[index] = value / sumDistance;
            });
            this.pointPercentArr = disPerSumArr;
        }
        // 上一次的朝向 todo
        this.preUp = new THREE.Vector3(0, 0, 0);
        // run函数需要的数据
        this.perce = percePosition; // 控制当前位置占整条线百分比9
        this.speed = 0.005 * speed; // 控制是否运动
        this.turnFactor = 0; // 暂停时间因子
        this.turnSpeedFactor = 1; // 转向速度因子
        this.obj = null;
        this.preTime = new Date().getTime();
        this.firstTurn = false;
    }
    // 模型对象旋转的函数，每次设置一个坐标轴的变换
    rotateAroundWorldAxis(object, axis, radians) {
        const rotWorldMatrix = new THREE.Matrix4();
        rotWorldMatrix.makeRotationAxis(axis.normalize(), radians);
        rotWorldMatrix.multiply(object.matrix);
        object.matrix = rotWorldMatrix;
        object.rotation.setFromRotationMatrix(object.matrix);
    }
    // 获取点，是否转弯，朝向等
    getPoint(percent) {
        let indexP = 0;
        let indexN = 0;
        let turn = false;
        // length提取 todo
        const pointLength = this.pointPercentArr.length;
        for (let i = 0; i < pointLength; i++) {
            if (percent >= this.pointPercentArr[i] && percent < this.pointPercentArr[i + 1]) {
                indexN = i + 1;
                indexP = i;
                if (percent === this.pointPercentArr[i]) {
                    turn = true;
                }
            }
        }
        const factor = (percent - this.pointPercentArr[indexP]) / (this.pointPercentArr[indexN] - this.pointPercentArr[indexP]);
        const position = new THREE.Vector3();
        position.lerpVectors(this.pointsArr[indexP], this.pointsArr[indexN], factor); // position的计算完全正确
        // 计算朝向
        const up = new THREE.Vector3().subVectors(this.pointsArr[indexN], this.pointsArr[indexP]);
        const preUp = this.preUp;
        if (this.preUp.x !== up.x || this.preUp.y !== up.y || this.preUp.z !== up.z) {
            // 当前朝向与上次朝向不等，将turn置为true
            turn = true;
        }
        this.preUp = up;
        return {
            position,
            direction: up,
            nextPosition: this.pointsArr[indexN],
            turn,
            preUp, // 当需要转向时的上次的方向
        };
    }
    // 物体沿线移动方法
    async moveOnCurve(model, modelType) {
        if (this.lineType !== 'Full line') {
            this.flowingLineTexture.offset.x -= 0.05;
        }
        if (this.curve == null || model == null) {
            // console.log("Loading");
        }
        else {
            if (this.progress <= 1 - this.velocity) {
                const point = this.pathCurve.getPointAt(this.progress); // 获取样条曲线指定点坐标
                const pointBox = this.pathCurve.getPointAt(this.progress + this.velocity); // 获取样条曲线指定点坐标
                if (point && pointBox) {
                    model.position.set(point.x, point.y, point.z);
                    // 因为这个模型加载进来默认面部是正对Z轴负方向的，所以直接lookAt会导致出现倒着跑的现象，这里用重新设置朝向的方法来解决。
                    const targetPos = pointBox; // 目标位置点
                    let offsetAngle;
                    if (modelType === 'Person') {
                        // 目标移动时的朝向偏移
                        offsetAngle = 3;
                    }
                    else {
                        offsetAngle = 0;
                    }
                    // //以下代码在多段路径时可重复执行
                    const mtx = new THREE.Matrix4(); // 创建一个4维矩阵
                    // .lookAt ( eye : Vector3, target : Vector3, up : Vector3 ) : this,构造一个旋转矩阵，从eye 指向 target，由向量 up 定向。
                    mtx.lookAt(model.position, targetPos, model.up); // 设置朝向
                    mtx.multiply(new THREE.Matrix4().makeRotationFromEuler(modelType === 'Person' ? new THREE.Euler(0, offsetAngle, 0) : new THREE.Euler(-1.54, offsetAngle, 1.54)));
                    const toRot = new THREE.Quaternion().setFromRotationMatrix(mtx); // 计算出需要进行旋转的四元数值
                    model.quaternion.slerp(toRot, 1); // 应用旋转。0.2代表插值step。可以做到平滑旋转过渡
                }
                this.progress += this.velocity;
            }
            else {
                this.progress = 0;
            }
        }
    }
    // 参数：是否运动，运动的对象，是否运动到结尾
    // run(camera: THREE.PerspectiveCamera, modelType: string) {
    //   if (this.lineType !== 'Full line') {
    //     this.flowingLineTexture.offset.x -= 0.05
    //   }
    //   // 转弯时
    //   if (this.obj && (this.obj as { turn: boolean }).turn) {
    //     if (this.turnFactor === 0) {
    //       this.preTime = new Date().getTime();
    //       this.turnFactor += 0.0001;
    //     } else {
    //       const nowTime = new Date().getTime();
    //       const timePass = nowTime - this.preTime;
    //       this.preTime = nowTime;
    //       this.turnFactor += this.turnSpeedFactor;
    //     }
    //     // console.log('--->>> 当前需要turn , turnFactor值为 :', this.turnFactor);
    //     if (this.turnFactor > 1) {
    //       this.turnFactor = 0;
    //       this.perce += this.speed;
    //       this.obj = this.getPoint(this.perce) as never;
    //     } else {
    //       // 修改朝向 (向量线性插值方式)
    //       if (modelType !== 'Person') {
    //         const interDirec = new THREE.Vector3();
    //         // 车模型转动方向
    //         interDirec.lerpVectors(
    //           (this.obj as { preUp: THREE.Vector3 }).preUp?.clone().normalize(),
    //           (this.obj as { direction: THREE.Vector3 }).direction.clone().normalize(),
    //           this.turnFactor
    //         );
    //         camera.lookAt((this.obj as { position: THREE.Vector3 }).position.clone().add(interDirec.clone()));
    //         const v1 = interDirec.clone().cross(new THREE.Vector3(0, 1, 0)).normalize();
    //         const v2 = interDirec.clone().cross(v1).normalize();
    //         camera.rotateOnWorldAxis(v1, Math.PI / 2);
    //         camera.rotateOnWorldAxis(v2, Math.PI / 2);
    //       } else {
    //         // 人模型转动方向
    //         // 修改朝向 (向量线性插值方式)
    //         const interDirec = new THREE.Vector3();
    //         interDirec.lerpVectors(
    //           (this.obj as { preUp: THREE.Vector3 }).preUp,
    //           (this.obj as { direction: THREE.Vector3 }).direction,
    //           this.turnFactor
    //         );
    //         let look = new THREE.Vector3();
    //         look = look.add((this.obj as { position: THREE.Vector3 }).position);
    //         look = look.add(interDirec);
    //         camera.lookAt(look); // 相机漫游1
    //       }
    //     }
    //   } else {
    //     this.obj = this.getPoint(this.perce);
    //     if (modelType !== 'Person') {
    //       // 修改位置
    //       const posi = (this.obj as { position: THREE.Vector3 }).position;
    //       camera.position.set(posi.x, posi.y, posi.z); // 相机漫游2
    //       camera.lookAt((this.obj as { nextPosition: THREE.Vector3 }).nextPosition);
    //       // 先绕前进的方向的右垂线旋转90°
    //       const direction = (this.obj as { nextPosition: THREE.Vector3 }).nextPosition.clone().sub(posi);
    //       const v1 = direction.clone().cross(new THREE.Vector3(0, 1, 0)).normalize();
    //       const v2 = direction.clone().cross(v1).normalize();
    //       camera.rotateOnWorldAxis(v1, Math.PI / 2);
    //       camera.rotateOnWorldAxis(v2, Math.PI / 2);
    //       // 当不需要转向时进行
    //       if (!(this.obj as { turn: boolean }).turn) {
    //         const look = posi.add((this.obj as { direction: THREE.Vector3 }).direction);
    //       }
    //       this.perce += this.speed;
    //     } else {
    //       // 人模型转动方向
    //       const posi = (this.obj as { position: THREE.Vector3 }).position;
    //       camera.position.set(posi.x, posi.y, posi.z); // 相机漫游2
    //       // 当不需要转向时进行
    //       if (!(this.obj as { turn: boolean }).turn) {
    //         const look = posi.add((this.obj as { direction: THREE.Vector3 }).direction);
    //         camera.lookAt(look); // 相机漫游3
    //       }
    //       this.perce += this.speed;
    //     }
    //   }
    // }
    dispose() {
        this.line?.material?.dispose();
        this.line?.geometry?.dispose();
        this.line?.remove?.();
    }
}
class Path3D extends Group {
    props;
    cone = new THREE.Mesh();
    openPatrolMode = false;
    coneArr = [];
    allCone = [];
    animation;
    mixer = [];
    models = [];
    // model?: THREE.Mesh;
    dom;
    static gltf;
    static model;
    static animations;
    static circle = new THREE.Mesh(new THREE.CircleGeometry(0.4, 32), new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        transparent: true,
        depthTest: true,
    }));
    circle;
    model;
    animateId = -1;
    clock;
    action;
    modelSize; // 模型大小
    prePropsStr;
    constructor(data) {
        super();
        this.clock = new Clock();
        this.props = data;
        this.prePropsStr = '';
        this.name = this.uuid;
        this.modelSize = new THREE.Vector3();
        this.dom = this.setHTML();
        // 初始化
        this.update(data);
    }
    dispose(isTemp = false) {
        const imgs = document.getElementsByClassName('patrolText');
        imgs &&
            imgs.length &&
            Array.from(imgs)?.forEach((img) => {
                img.remove();
            });
        this.models = [];
        this.mixer = [];
        this.traverse((obj) => {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            const txtLabel = obj?.getObjectByName('txtLabel');
            if (txtLabel) {
                txtLabel?.element.remove();
            }
            if (obj.parent && !isTemp) {
                obj?.parent.remove(obj);
            }
            obj.clear();
        });
        if (!isTemp) {
            this.clock.stop();
            window.cancelAnimationFrame(this.animateId);
            this.clear();
            this.parent?.remove(this);
            if (this.props?.onDestory && typeof this.props?.onDestory === 'function') {
                this.props?.onDestory(this);
            }
        }
    }
    bindHtmlEvent(cone, html, name) {
        if (this.props?.renderProps?.patrol && !this.props?.renderProps?.isClick) {
            // 开启巡视模式
            html.onclick = () => {
                screenStore.updateSingleMapData({
                    key: 'operationMode',
                    value: 'cruise',
                });
                screenStore.updateCurrentCone(cone);
                screenStore.updateChosePathIndex(name);
            };
        }
    }
    createPolygon(cone, isCar = false, name) {
        const geometry2 = new THREE.BoxGeometry(0, 5, 6);
        const material2 = new THREE.MeshBasicMaterial({ color: 15245878, side: THREE.DoubleSide });
        const mesh2 = new THREE.Mesh(geometry2, material2);
        const lableH = 6;
        const modelH = this.modelSize.y;
        mesh2.material.visible = false;
        const dom = this.dom.cloneNode(true);
        this.bindHtmlEvent(cone, dom, name);
        const htmlMesh = new CSS2DObject(dom);
        htmlMesh.name = 'txtLabel';
        const tragetH = lableH + modelH;
        if (isCar) {
            mesh2?.position?.set(0, 0, tragetH / (cone.scale.y));
        }
        else {
            mesh2.position.y = tragetH;
        }
        mesh2.add(htmlMesh);
        return mesh2;
    }
    setHTML() {
        const div = document.createElement('div');
        div.innerText = 'Patrol';
        div.style.width = '54px';
        div.style.height = '22px';
        div.style.background = '#FFCC00';
        div.style.textAlign = 'center';
        div.style.lineHeight = '22px';
        div.style.opacity = '0.8';
        div.style.border = '1px solid #1C1F23';
        div.style.borderRadius = '2px';
        div.className = 'patrolText';
        // div.onclick = () => {
        // if (this.props?.renderProps?.patrol && !this.props?.renderProps?.isClick) {
        //   // 开启巡视模式
        //   screenStore.updateSingleMapData({
        //     key: 'operationMode',
        //     value: 'cruise',
        //   });
        //   screenStore.updateCurrentCone(cone);
        // }
        // };
        // this.dom = div;
        return div;
    }
    async loadCarModel() {
        const loader = new GLTFLoader();
        await new Promise((resolve, reject) => {
            loader.load('/Mod_Car-0926.gltf', (gltf) => {
                this.model = gltf.scene.getObjectByName('Mod_Car');
                this.model.traverse((object) => {
                    if (object.isMesh) {
                        object.material.color.set('white');
                        object.material.transparent = true;
                        object.material.depthTest = true;
                        object.material.emissive.set('white');
                        object.material.opacity = 1;
                    }
                });
                this.model.scale.set(0.01, 0.01, 0.01);
                this.modelSize = getModelSize(gltf.scene);
                resolve(this.model);
            }, (progress) => { }, (err) => {
                reject(err);
            });
        });
    }
    async loadPersonModel(count) {
        await loadePerson(Gender.UNKNOWN).then((res) => {
            console.log(res, 'res');
            for (let index = 0; index < count; index++) {
                const material = new THREE.MeshBasicMaterial();
                const geometry = new THREE.CylinderBufferGeometry(10, 10, 10, 10);
                geometry.rotateX(Math.PI / 2);
                const cone = new THREE.Mesh(geometry, material.clone()); // 包裹模型的多边体 方便支持点击事件
                cone.scale.set(1, 1, 1);
                cone.isObserver = true;
                cone.material.visible = false;
                res.scene.scale.set(100, 100, 100);
                this.model = cone;
                this.modelSize = getModelSize(res.scene);
                const model = clone(res.scene); // 人物模型
                const mixer = new AnimationMixer(model);
                mixer.clipAction(res.animations[1]).play();
                this.model?.add(model);
                this.models.push(this.model);
                this.mixer.push(mixer);
            }
        });
    }
    // disposeTempData() {
    //   this.pathLine?.dispose();
    // }
    // 模型对象旋转的函数，每次设置一个坐标轴的变换
    rotateAroundWorldAxis(object, axis, radians) {
        const rotWorldMatrix = new THREE.Matrix4();
        rotWorldMatrix.makeRotationAxis(axis.normalize(), radians);
        rotWorldMatrix.multiply(object.matrix);
        object.matrix = rotWorldMatrix;
        object.rotation.setFromRotationMatrix(object.matrix);
    }
    // 初始化线条和点
    async update(data) {
        const currentPropsStr = JSON.stringify(data);
        if (this.prePropsStr !== currentPropsStr) {
            this.prePropsStr = currentPropsStr;
        }
        else {
            return;
        }
        this.dispose(true);
        // this.disposeTempData();
        // 反向处理，坐标转换
        if (data?.renderProps?.cycle) {
            data?.renderProps?.points?.reverse();
        }
        this.props = data;
        const isPerson = this.props?.renderProps?.covering?.key === 'Person';
        const _that = this;
        // 点击模型开启巡视模式
        function mousedown(e) {
            if (e.mapTarget && _that.coneArr.includes(e.mapTarget.uuid)) {
                if (_that.props?.renderProps?.patrol && !_that.props?.renderProps?.isClick) {
                    // 开启巡视模式
                    screenStore.updateChosePathIndex(_that.props?.renderProps.name);
                    screenStore.updateSingleMapData({
                        key: 'operationMode',
                        value: 'cruise',
                    });
                    screenStore.updateCurrentCone(e.mapTarget);
                }
            }
        }
        store?.interactControls?.addEventListener('click', mousedown);
        const coverring = this.props?.renderProps?.coveringCount || 1;
        // 获取数据进行计算出每个点位所在位置占总线段的百分比
        const array = [];
        const newArr = [];
        for (let index = 0; index < coverring; index++) {
            array.push((index + 1) * (1 / coverring));
        }
        if (isPerson) {
            await this.loadPersonModel(array.length);
        }
        else {
            await this.loadCarModel();
        }
        // 获取任意两点的随机数
        array.map((item, index) => {
            if (index < array.length - 1) {
                newArr.push(rand(array[index] * 100, array[index + 1] * 100) / 100);
            }
        });
        // 首点为起点
        newArr.unshift(0);
        // 获取画线的点
        const arrayPoints = getPointList(this.props?.renderProps?.points);
        // // new path 创建路径
        this.allCone.forEach((cone) => {
            cone.geometry.dispose();
            cone.material.dispose();
            cone.remove();
            if (cone.parent) {
                cone?.parent.remove(cone);
            }
            cone.clear();
        });
        array.forEach((item, index) => {
            // 后边模型和覆盖物替换
            // const cone = clone(this.model) as unknown as THREE.Mesh  & { isObserver: boolean };
            const cone = isPerson
                ? this.models?.[index]
                : this.model?.clone();
            if (!cone)
                return;
            if (_that.props?.renderProps?.patrol) {
                const htmlMesh = this.createPolygon(cone, !isPerson, _that.props?.renderProps.name);
                cone.add(htmlMesh);
            }
            cone.isObserver = true;
            this.coneArr.push(cone.uuid);
            this.allCone.push(cone);
            if (this.props?.renderProps?.coveringCount > 0) {
                this.add(cone);
            }
            // eslint-disable-next-line new-cap
            const pathLine = new MyPath(arrayPoints, this.props?.renderProps?.speed, this.props?.renderProps?.width, item, this.props?.renderProps?.cycle, this.props?.renderProps?.type, cone);
            // 添加点和路径
            const runMesh = cone;
            if (index === 0) {
                if (this.props?.renderProps?.coveringCount > 0 && _that.props?.renderProps?.patrol) {
                    screenStore.updatePathFirstConeArray({ cone: cone, pathName: _that.props?.renderProps.name });
                    screenStore.updateCurrentCone(cone);
                }
                pathLine.line.visible = this.props?.renderProps?.show;
                this.add(pathLine.line);
            }
            const animate = () => {
                this.animateId = requestAnimationFrame(animate);
                // pathLine.run(
                //   runMesh as THREE.Mesh as unknown as never,
                //   (this.props?.renderProps as { covering: { key: unknown } }).covering?.key as string
                // );
                pathLine.moveOnCurve(cone, this.props?.renderProps.covering?.key);
                // if (this.props?.renderProps?.type === 'Pulse') {
                //   (pathLine.line.material as any).uniforms.offset.value.x -= 0.01;
                // } else {
                //   (pathLine.line.material as any).uniforms.offset.value.x -= 0.0001;
                // }
                if (!store?.camera || !store?.controls)
                    return;
                if (screenStore.mapData.operationMode === 'cruise' && _that.props?.renderProps?.patrol) {
                    // 巡视模式开启字段
                    store.controls.target.copy(screenStore.currentCone[0].position);
                    // 巡视模式开启得时候 地图旋转差值需要记录
                    store.controls && (store.controls.maxDistance = 45);
                    store.camera.position.y = store.controls.target.y + 15;
                }
                const deltaTime = this.clock.getDelta();
                console.log('deltaTime', deltaTime);
                if (this.props?.renderProps?.covering?.key === 'Person') {
                    for (const mixer of this.mixer)
                        mixer.update(deltaTime);
                }
                // 路程循环
                // if (pathLine.perce >= 1) {
                //   pathLine.perce = 0;
                // }
            };
            animate();
        });
    }
}
export default Path3D;
